import CollectionLogo from './collection-logo';

export default CollectionLogo;
